/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Accept_NoteInputs */

const en_us2_coaching_accept_note = /** @type {(inputs: Coaching_Accept_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you accept, the trainer sees your workouts, measurements and plan, and can build your plan. They never see your conversations with the AI. You can leave whenever you want.`)
};

const pt_br2_coaching_accept_note = /** @type {(inputs: Coaching_Accept_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao aceitar, o personal passa a ver seus treinos, medidas e plano, e pode montar seu plano. Ele nunca vê suas conversas com a IA. Você pode sair quando quiser.`)
};

const pt_pt2_coaching_accept_note = /** @type {(inputs: Coaching_Accept_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao aceitar, o personal passa a ver seus treinos, medidas e plano, e pode montar seu plano. Ele nunca vê suas conversas com a IA. Você pode sair quando quiser.`)
};

/** @type {(inputs: Coaching_Accept_NoteInputs) => LocalizedString} */
const es_419_coaching_accept_note = en_us2_coaching_accept_note;

/** @type {(inputs: Coaching_Accept_NoteInputs) => LocalizedString} */
const fr_fr2_coaching_accept_note = en_us2_coaching_accept_note;

/** @type {(inputs: Coaching_Accept_NoteInputs) => LocalizedString} */
const de_de2_coaching_accept_note = en_us2_coaching_accept_note;

/** @type {(inputs: Coaching_Accept_NoteInputs) => LocalizedString} */
const it_it2_coaching_accept_note = en_us2_coaching_accept_note;

/**
* | output |
* | --- |
* | "Once you accept, the trainer sees your workouts, measurements and plan, and can build your plan. They never see your conversations with the AI. You can leave..." |
*
* @param {Coaching_Accept_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_accept_note = /** @type {((inputs?: Coaching_Accept_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Accept_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_accept_note(inputs)
	if (locale === "es-419") return es_419_coaching_accept_note(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_accept_note(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_accept_note(inputs)
	if (locale === "de-DE") return de_de2_coaching_accept_note(inputs)
	if (locale === "it-IT") return it_it2_coaching_accept_note(inputs)
	return en_us2_coaching_accept_note(inputs)
});
export { coaching_accept_note as "coaching.accept_note" }